import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { Container, CardBody, Card, Row, Col } from "reactstrap";
import proImg from "../../../assets/images/proImg.png";
import seler from "../../../assets/images/seller.svg";
import business from "../../../assets/images/business.svg";
import acount from "../../../assets/images/acount.svg";
import bankAccount from "../../../assets/images/bankAccount.svg";
import commission from "../../../assets/images/commission.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { toast } from "react-toastify";
import ErrorModal from "Components/Common/ErrorModal";

interface Seller {
  sellerId: string;
  storeName: string;
  email: string;
  phoneNumber: string;
  name: string;
  holiday: {
    holidayMode: boolean;
  };
  _id: string;
  firstName: string;
  buypassId : string;
}

const Setting = () => {
  document.title = "Account Setting | BuyPass";

  const selectuserProfile = createSelector(
    (state: any) => state.Business,
    (business) => business?.business
  );
  const seller = useSelector(selectuserProfile);
  const [parsedSeller, setParsedSeller] = useState<Seller | null>(null);

    const [errorMessage, setErrorMessage] = useState<string>("");
    const [showModal, setShowModal] = useState({
        isVisible: false,
        color: false,
      });
    

    useEffect(() => {
        if (seller) {
            setParsedSeller(seller);
        }
    }, [seller]);


    return (
        <div className="page-content">
            <ErrorModal
                    show={showModal.isVisible}
                    message={errorMessage}
                    color={showModal.color}
                    onCloseClick={() => setShowModal({ isVisible: false, color: false })}
                />

            <Container fluid>
                {/* <BreadCrumb title="Home > Setting"  /> */}
                <BreadCrumb title=" Settings" pageTitle="My-Account" pageTitleRoute="/my-account-setting" />
                <Card>
                    <CardBody className="rounded-3">
                        <div className="d-flex justify-content-start align-items-center border-bottom border-light border-2 pb-3">
                            <div className="rounded-circle me-3 bg-light" style={{ width: '90px', height: "90px" }}>
                                <img src={seller?.shopLogo?.url || proImg}
                                    style={{ width: '89px', height: "89px" }}
                                    className="m-0 p-0"
                                    alt="" />
                            </div>
                            <div>
                                <h3 className="break-text mb-2 fw-bolder p-0">
                                    {parsedSeller?.storeName || "--"}
                                    <span className="text-primary ms-2 cursor-pointer">
                                        {/* <i className="ri-edit-line"></i> */}
                                    </span>
                                </h3>

                                <p className="break-text m-0 p-0">
                                    Seller ID: {parsedSeller?.buypassId}
                                    <span
                                        className="text-danger cursor-pointer"
                                        onClick={() => {
                                            if (parsedSeller?.buypassId) {
                                                navigator.clipboard.writeText(parsedSeller.buypassId);
                                                // toast.success("Seller ID copied!", { autoClose: 1000 });
                                                setShowModal({ isVisible: true, color: true });
                                                console.log("Seller ID copied!")
                                                setErrorMessage("Seller ID copied!")
                                                setTimeout(() => {
                                                    setShowModal({ isVisible: false, color: true });
                                                }, 1000);
                                                return;
                                            }
                                        }}
                                    >
                                        <i className="ri-folders-line"></i>
                                    </span>
                                </p>


                                {/* <p className="break-text m-0 p-0">Store URL: https://www.daraz.pk/shop/1mzdtnmq  <span className="text-danger  cursor-pointer"><i className="ri-folders-line"></i></span></p> */}
                            </div>
                        </div>
                        <h3 className="my-3 fw-bolder p-0">Business Information </h3>
                        <Row >

                            <Col md={3} sm={12} xs={12} lg={3}>
                                <Link to="/seller-profile" className="rounded  bg-light p-3 mb-2  d-flex justify-content-start align-items-center cursor-pointer" data-testing-Id="sellerProfile_setting" style={{ height: "80px" }}>
                                    <img src={seler} alt="" className="me-3" style={{ width: '45px', height: "45px" }} />
                                    <div>
                                        <h5 className="mb-2 p-0 fw-bolder">Seller Profile</h5>
                                        <p className="p-0 m-0 text-black-50">Manage Seller Profile</p>
                                    </div>
                                </Link>
                            </Col>

                            <Col md={3} sm={12} xs={12} lg={3}>
                                <Link to="/business-information" className="rounded  bg-light p-3 mb-2 d-flex justify-content-start align-items-center cursor-pointer" data-testing-Id="businessInformation_setting" style={{ height: "80px" }}>
                                    <img src={business} alt="" className="me-3" style={{ width: '45px', height: "45px" }} />
                                    <div>
                                        <h5 className="mb-2 p-0 fw-bolder">Business Information</h5>
                                        <p className="p-0 m-0 text-black-50">Your identity info</p>
                                    </div>
                                </Link>
                            </Col>

                            <Col md={3} sm={12} xs={12} lg={3}>
                                <Link to="/account-setting" className="rounded  bg-light p-3 mb-2  d-flex justify-content-start align-items-center cursor-pointer" data-testing-Id="accountSetting_setting" style={{ height: "80px" }}>
                                    <img src={acount} alt="" className="me-3" style={{ width: '45px', height: "45px" }} />
                                    <div>
                                        <h5 className="mb-2 p-0 fw-bolder">Account Settings</h5>
                                        <p className="p-0 m-0 text-black-50 ">Manage Login Account</p>
                                    </div>
                                </Link>
                            </Col>


                        </Row>
                        <h3 className="my-3 fw-bolder p-0">Finance</h3>

                        <Row >
                            <Col md={3} sm={12} xs={12} lg={3}>
                                <Link to="/bank-account" className="rounded mb-2 bg-light p-3  d-flex justify-content-start align-items-center cursor-pointer" data-testing-Id="bankAccount_setting" style={{ height: "80px" }}>
                                    <img src={bankAccount} alt="" className="me-3" style={{ width: '45px', height: "45px" }} />
                                    <div>
                                        <h5 className="mb-2 p-0 fw-bolder">Bank Account</h5>
                                        <p className="p-0 m-0 text-black-50">Manage Bank</p>
                                    </div>
                                </Link>
                            </Col>
                            {/* <Link to=""  className="rounded me-3 bg-light p-3 w-25 d-flex justify-content-start align-items-center cursor-pointer" style={{ height:"80px"}}>
                            <img src={commission} alt="" className="me-3" style={{width:'45px' , height:"45px"}} />
                        <div>
                            <h5 className="mb-2 p-0 fw-bolder">Commission</h5>
                            <p  className="p-0 m-0 text-black-50">Manage Commission</p>
                        </div>
                       </Link> */}
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default Setting;
